<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="dataflow-04">
      <path
        id="Icon"
        d="M6.13591 24V23.7333C6.13591 21.4931 6.1359 20.373 6.57188 19.5174C6.95537 18.7647 7.56729 18.1528 8.31994 17.7693C9.17559 17.3333 10.2957 17.3333 12.5359 17.3333H21.0692C23.3094 17.3333 24.4296 17.3333 25.2852 17.7693C26.0379 18.1528 26.6498 18.7647 27.0333 19.5174C27.4692 20.373 27.4692 21.4931 27.4692 23.7333V24M6.13591 24C4.66315 24 3.46924 25.1939 3.46924 26.6667C3.46924 28.1394 4.66315 29.3333 6.13591 29.3333C7.60866 29.3333 8.80257 28.1394 8.80257 26.6667C8.80257 25.1939 7.60866 24 6.13591 24ZM27.4692 24C25.9965 24 24.8026 25.1939 24.8026 26.6667C24.8026 28.1394 25.9965 29.3333 27.4692 29.3333C28.942 29.3333 30.1359 28.1394 30.1359 26.6667C30.1359 25.1939 28.942 24 27.4692 24ZM16.8026 24C15.3298 24 14.1359 25.1939 14.1359 26.6667C14.1359 28.1394 15.3298 29.3333 16.8026 29.3333C18.2753 29.3333 19.4692 28.1394 19.4692 26.6667C19.4692 25.1939 18.2753 24 16.8026 24ZM16.8026 24V10.6667M8.80257 10.6667H24.8026C26.0451 10.6667 26.6663 10.6667 27.1564 10.4637C27.8098 10.193 28.3289 9.6739 28.5996 9.02049C28.8026 8.53043 28.8026 7.90918 28.8026 6.66666C28.8026 5.42415 28.8026 4.8029 28.5996 4.31284C28.3289 3.65943 27.8098 3.1403 27.1564 2.86965C26.6663 2.66666 26.0451 2.66666 24.8026 2.66666H8.80257C7.56006 2.66666 6.93881 2.66666 6.44875 2.86965C5.79534 3.1403 5.27621 3.65943 5.00556 4.31284C4.80257 4.8029 4.80257 5.42415 4.80257 6.66666C4.80257 7.90918 4.80257 8.53043 5.00556 9.02049C5.27621 9.6739 5.79534 10.193 6.44875 10.4637C6.93881 10.6667 7.56006 10.6667 8.80257 10.6667Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
